<template>
  <div class="">
    <div class="lg:flex md:flex mb-5">
      <div class="lg:w-5/12 md:w-5/12 relative">
        <Map5 />
      </div>
      <div
        class="lg:w-7/12 md:w-7/12 lg:mt-28 md:mt-20 mt-4 lg:px-8 md:px-8 px-5"
      >
        <Grid5 :location="location" />
        <!-- <Pagination /> -->
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import Map5 from "./components/Map5.vue";
import Grid5 from "./components/Grid5.vue";
import Pagination from "./components/Paginationn.vue";

export default {
  props: ["location"],
  components: {
    Map5,
    Footer,
    DownloadApp,
    Grid5,
    Pagination,
  },
  async mounted() {
    // this.userDetails = sessionStorage.getItem("token");
    // try {
    //   if (this.userDetails === null) {
    //     this.$swal
    //       .fire({
    //         title: "Login!",
    //         text: "Please login to continue",
    //         icon: "info",
    //         confirmButtonText: "Okay",
    //         confirmButtonColor: "#830c81",
    //         showCancelButton: false,
    //       })
    //       .then((result) => {
    //         return this.$router.push({ name: "signin" });
    //       });
    //     return;
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  },
};
</script>

<style></style>
